import '@/services/events/mockEventsService';
import ReactDOM from 'react-dom/client';
import './styles/main.css';
import {useEffect} from 'react';
import {Provider, useSelector} from 'react-redux';
import {BrowserRouter} from 'react-router';
import AppRoutes from '@/containers/Routes/AppRoutes';
import useEvents from '@/hooks/useEvents';
import useExternalLinkReturnRefetch from '@/hooks/useExternalLinkReturnRefetch';
import useNavigateInit from '@/hooks/useNavigateInit';
import useNavigationTracker from '@/hooks/useNavigationTracker';
import {selectIsInitialized, selectPadding} from '@/state/selectors/app';
import {configureStore} from '@/state/store';

const App = () => {
    useEvents();
    useNavigateInit();
    useExternalLinkReturnRefetch();
    useNavigationTracker();

    const isInitialized = useSelector(selectIsInitialized);
    const padding = useSelector(selectPadding);

    useEffect(() => {
        const root = document.documentElement;
        root.style.setProperty('--app-padding-top', `${padding.top ?? 0}px`);
        root.style.setProperty('--app-padding-bottom', `${padding.bottom ?? 0}px`);
        root.style.setProperty('--app-padding-bottom-menu', `${padding.bottomMenu ?? padding.bottom ?? 0}px`);
    }, [padding]);

    return (
        <div className='flex h-screen w-full flex-col bg-tnemec-black text-romance'>
            {isInitialized && <AppRoutes />}
        </div>
    );
};

const start = () => {
    const store = configureStore();
    const container = document.getElementById('root');
    if (!container) return;

    const root = ReactDOM.createRoot(container);
    root.render(
        <Provider store={store}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </Provider>
    );
};

start();
